/**
 * <ReferralStatsCard> — les quatre compteurs du tableau de parrainage (organism).
 *
 * Les libellés appartiennent au composant, comme le menu d'une carte de séance : un seul jeu de
 * mots pour tous les appelants. Les chiffres arrivent en props — et le quatrième n'est pas un
 * compte mais un montant, déjà formaté par le view-model.
 *
 * La grille se replie toute seule : deux tuiles par rangée sur un téléphone, quatre sur une page
 * large, sans point de rupture à tenir.
 */
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Card } from "../../molecules/Card"
import { ReferralStatTile } from "../../molecules/ReferralStatTile"
import { type UIReferralStats } from "../../../ports/primary/ui/types"

export type ReferralStatsCardProps = {
    stats: UIReferralStats
    testID?: string
}

export function ReferralStatsCard(props: ReferralStatsCardProps) {
    const { stats, testID } = props

    const tiles = [
        { key: "clicks", value: String(stats.clicks), label: "Clics sur le lien" },
        { key: "accounts", value: String(stats.accountsCreated), label: "Comptes créés" },
        { key: "activated", value: String(stats.activatedReferrals), label: "Filleuls activés" },
        { key: "reward", value: stats.rewardPerReferralLabel, label: "Bonus par filleul" },
    ]

    return (
        <Card p="4" testID={testID}>
            <View style={styles.grid}>
                {tiles.map((tile) => (
                    <View key={tile.key} style={styles.cell}>
                        <ReferralStatTile value={tile.value} label={tile.label} />
                    </View>
                ))}
            </View>
        </Card>
    )
}

const styles = StyleSheet.create((theme) => ({
    grid: {
        flexDirection: "row",
        flexWrap: "wrap",
        gap: theme.spacing["3"],
    },
    /**
     * Deux tuiles par rangée, quelle que soit la largeur : une base de 45 % en interdit une
     * troisième (3 × 45 > 100). Une base en pixels laissait passer un 3 + 1 boiteux dès que la
     * carte dépassait 480 px — quatre compteurs se lisent en carré, jamais en 3 + 1.
     */
    cell: { flexGrow: 1, flexBasis: "45%" },
}))
